import React from 'react';
import Image from 'next/image';
import { useTranslations } from 'next-intl';

import GenerateStar from './GenerateStar';
import type {
  RestaurantReview,
  ReviewComment,
} from '@/lib/types/customer/restaurant/StoreReview';

import { dayFormat } from '@/lib/helpers/functions';
import { useParams } from 'next/navigation';
type Props = {
  review: RestaurantReview;
  storeName: string;
  thumb_url: string;
};
export default function SingleReview({ review, storeName, thumb_url }: Props) {
  const t = useTranslations('storefront.store_profile');
  const lang = useParams().locale.slice(0, 2) as string;
  return (
    <div className="mt-[60px]">
      <div className="flex items-start gap-x-[20px]">
        <div className="relative h-[40px] w-[40px] shrink-0 overflow-hidden rounded-full">
          <Image
            src={
              review.is_anonymous
                ? '/avatar.jpg'
                : review.user?.media?.avatar?.[0].url ?? '/avatar.jpg'
            }
            fill
            alt={`avatar of ${review.user.full_name}`}
            style={{ objectFit: 'cover' }}
          />
        </div>
        <div className="w-full">
          <div className="mb-[20px] flex flex-col gap-y-[10px] md:flex-row md:justify-between md:gap-y-0">
            <div className="flex flex-col">
              <span className="text-h6 font-bold">
                {review.is_anonymous ? t('annonymous') : review.user.full_name}
              </span>
              <span className="text-sm text-paragraph">
                {dayFormat(review?.created_at).locale(lang).format('ll')}
              </span>
            </div>
            <span className="flex">
              <GenerateStar numberOfStars={review.avg_rating} />
            </span>
          </div>
          <p className="mb-[20px] text-sm text-paragraph">{review.review}</p>
          {/* <button className="rounded-[30px] border-2 border-neutral-100 px-[30px] py-[10px] text-paragraph">
        Helpful review | 20
      </button> */}
          {review.review_comment && (
            <SingleReviewOwner
              comment={review.review_comment}
              storeName={storeName}
              thumb_url={thumb_url}
            />
          )}
        </div>
      </div>
    </div>
  );
}

type PropsOwner = {
  comment: ReviewComment;
  storeName: string;
  thumb_url: string;
};

function SingleReviewOwner({ comment, storeName, thumb_url }: PropsOwner) {
  const t = useTranslations('storefront.store_profile');
  const lang = useParams().locale.slice(0, 2) as string;
  return (
    <div className="mt-[60px]">
      <div className="flex items-start gap-x-[20px]">
        <div className="relative h-[40px] w-[40px] shrink-0 overflow-hidden rounded-full">
          <Image
            src={thumb_url ?? '/avatar.jpg'}
            fill
            alt={`avatar of ${storeName}`}
            style={{ objectFit: 'cover' }}
          />
        </div>
        <div className="">
          <div className="mb-[20px] flex flex-col gap-y-[10px] md:flex-row md:justify-between md:gap-y-0">
            <div className="flex flex-col">
              <span className="flex flex-col text-h6 font-bold md:flex-row">
                {storeName}
                <span className="w-fit rounded-[30px] bg-primary px-[12px] py-[4px] text-sm font-normal text-white md:ml-[15px]">
                  {t('owner')}
                </span>
              </span>
              <span className="text-sm text-paragraph">
                {dayFormat(comment?.created_at).locale(lang).format('ll')}
              </span>
            </div>
          </div>
          <p className="mb-[20px] text-sm text-paragraph">{comment.comment}</p>
        </div>
      </div>
    </div>
  );
}
